import React from 'react';
import {Formik, Form, Field, ErrorMessage} from 'formik';
import * as Yup from 'yup';
import {controlClass, fieldError, primaryButtonClass, Spinner} from '../formStyles';

const requestResetSchema = Yup.object({
  email: Yup.string()
    .email('Please enter a valid email address')
    .required('Email is required'),
});

interface RequestResetFormProps {
    initialEmail: string;
    submitting: boolean;
    onSubmit: (email: string) => Promise<void>;
}

const RequestResetForm: React.FC<RequestResetFormProps> = ({initialEmail, submitting, onSubmit}) => (
  <Formik
    initialValues={{email: initialEmail}}
    validationSchema={requestResetSchema}
    onSubmit={async (values, {setSubmitting}) => {
      await onSubmit(values.email.trim());
      setSubmitting(false);
    }}
    validateOnChange={false}
    validateOnBlur={false}
  >
    {({isSubmitting}) => {
      const busy = isSubmitting || submitting;

      return (
        <Form className="mt-5 space-y-3.5">
          <div>
            <label className="mb-1 block text-xs font-medium text-gray-300" htmlFor="email">
                            Email
            </label>
            <Field
              id="email"
              type="text"
              name="email"
              autoComplete="email"
              autoFocus
              className={controlClass}
              placeholder="you@example.com"
            />
            <ErrorMessage name="email">{fieldError}</ErrorMessage>
          </div>

          <button type="submit" disabled={busy} className={`w-full ${primaryButtonClass}`}>
            {busy && <Spinner />}
            {busy ? 'Sending…' : 'Send reset link'}
          </button>
        </Form>
      );
    }}
  </Formik>
);

export default RequestResetForm;
